// tslint:disable:no-any
export function makeModel(data: any, model: any): any {
    if (data) {
        if (Array.isArray(data)) {
            const response: any[] = [];
            data.map((item: any): void => {
                const modelData: any = new model();
                if (modelData.fromJson(item)) {
                    response.push(modelData);
                }
            });
            return response;
        }
        const response: any = new model();
        return response.fromJson(data) ? response : null;
    }
    return null;
}

export function capitalizeFirstLetter(str: string): string {
    return str.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : 'Error';
}